<template>
  <h1>GolstatsLive</h1>
</template>

<script>
export default {
  name: 'GolstatsLive',
};
</script>

<style scoped></style>
